import { Map as ImmutableMap, Set as ImmutableSet } from 'immutable'
import { AppEntitlementValue, CatalogEntryValue } from 'lib/actions/apps/app-entitlement'
import { AppEntitlement, AppEntitlementCorrelation } from 'pbts/c1/api/app/v1/app_entitlement'
import { AppEntitlementRef } from 'pbts/c1/api/app/v1/app_refs'

export const appEntitlementIdParts = (appId: string, appEntitlementId: string): string => {
    return `${appId}:${appEntitlementId}`
}

export const appEntitlementId = (ae: AppEntitlementValue | AppEntitlementRef | CatalogEntryValue): string => {
    return appEntitlementIdParts(ae.appId, ae.id)
}

export const appEntitlementsToMap = <T extends AppEntitlement>(aes: T[]): ImmutableMap<string, T> => {
    return ImmutableMap<string, T>(
        aes.map((ae) => {
            return [appEntitlementId(ae), ae]
        }),
    )
}

export const appEntitlementValuesToSet =
    (appEntitlementValues: AppEntitlementValue[]): ImmutableSet<string> =>
        ImmutableSet<string>(appEntitlementValues.map((ae) => appEntitlementId(ae)))

export const appEntitlementSetToRefs = (entitlements: ImmutableSet<string>): AppEntitlementRef[] => {
    const refs: AppEntitlementRef[] = []
    entitlements.forEach((e) => {
        const [appId, id] = e.split(':')
        refs.push({ appId, id })
    })
    return refs
}

export const appEntitlementRefsToSet = (refs: AppEntitlementCorrelation[]): ImmutableSet<string> => {
    return ImmutableSet<string>(refs.map((ref) => appEntitlementId(AppEntitlementRef.create({
        appId: ref.appEntitlement?.appId,
        id: ref.appEntitlement?.id,
    }))))
}
